import { currentUserSubject } from '../../components/Auth/Auth';
import jwt from 'jwt-decode';
import * as actionTypes from './actionTypes';
import axios from '../../axios';

export const setOpenStreakModal = (openStreakModal) => (dispatch) => {
	dispatch({
		type: actionTypes.SET_OPEN_STREAK_MODAL,
		openStreakModal
	});
};

export const updateUserError = (error) => (dispatch) => {
	dispatch({
		type: actionTypes.UPDATE_USER_ERROR,
		error
	});
};

export const updateUserStatus = (data) => (dispatch) => {
	dispatch({
		type: actionTypes.UPDATE_USER_STATUS,
		statusMessage: data.statusMessage
	});
};

export const loginUserStart = (error) => (dispatch) => {
	dispatch({
		type: actionTypes.LOGIN_USER_START,
		loading: true
	});
};

export const loginUserFail = (error) => (dispatch) => {
	dispatch({
		type: actionTypes.LOGIN_USER_FAIL,
		error
	});
};

const loginUserSuccess = (data) => (dispatch) => {
	dispatch({
		type: actionTypes.LOGIN_USER_SUCCESS,
		data: data.message
	});
};

const registerUserSuccess = (data) => (dispatch) => {
	dispatch({
		type: actionTypes.REGISTER_USER_SUCCESS,
		data: data.message
	});
};

const resetPasswordSuccess = (data) => (dispatch) => {
	dispatch({
		type: actionTypes.RESET_PASSWORD_SUCCESS
	});
};

const updatePasswordSuccess = (data) => (dispatch) => {
	dispatch({
		type: actionTypes.UPDATE_PASSWORD_SUCCESS
	});
};

export const registerUser = (credentials, navigate, setButtonLoading) => (dispatch) => {
	const userRegisterURL = '/api/register';
	axios
		.post(userRegisterURL, credentials)
		.then((response) => {
			navigate('/login');
			dispatch(registerUserSuccess(response.data));
		})
		.catch((err) => {
			setButtonLoading(false);

			if (err.response && err.response.data && err.response.data.error) {
				switch (err.response.status) {
					case 200:
						window.fbq('track', 'CompleteRegistration');
						break;
					case 409:
						dispatch(
							loginUserFail(
								`${err.response.data.error}<a href="/reset-password"> Resetează parola aici.</a>`
							)
						);
						break;
					case 400:
						dispatch(
							loginUserFail(
								'A apărut o eroare la procesarea înregistrării. Vă rugăm să verificați informațiile introduse și să încercați din nou.'
							)
						);
						break;
					default:
						dispatch(loginUserFail('Acest email este invalid, te rugam sa incerci cu alt email'));
						break;
				}
			}
		});
};

export const loginUser = (credentials, navigate, updateUser, setUserId) => (dispatch) => {
	dispatch(loginUserStart());

	const userLoginURL = '/api/login';
	axios
		.post(userLoginURL, credentials)
		.then((response) => {
			dispatch(loginUserSuccess(response.data));

			let userData;
			if (response?.data?.message?.User?.ID) {
				userData = {
					access: response.data.message.Access_Token,
					refresh: response.data.message.Refresh_Token,
					isAuthenticated: true,
					userId: response.data.message.User.ID,
					firstName: response.data.message.User.FirstName,
					isFirstLogin: response.data.message.User.IsFirstLogin
				};
			} else {
				userData = {
					access: response.data.message.Access_Token,
					refresh: response.data.message.Refresh_Token,
					isAuthenticated: true,
					userId: response.data.message.User.id,
					firstName: response.data.message.User.firstName,
					isFirstLogin: response.data.message.User.isFirstLogin
				};
			}
			// TODO: rename to user auth
			localStorage.setItem('userData', JSON.stringify(userData));
			setUserId(userData.userId);
			localStorage.setItem('user', JSON.stringify(response.data.message.User));

			// update user data part of the subscription context
			updateUser(userData);

			if (response.data && response.data.message) {
				currentUserSubject.next(response.data.message.Access_Token);
			}
			axios.defaults.headers.common.Authorization = `Bearer ${response.data.message.Access_Token}`;

			navigate('/');
		})
		.catch((err) => {
			if (err?.response && err?.response?.data && err?.response?.data.error) {
				switch (err?.response?.status) {
					case 400:
						dispatch(loginUserFail('Conectare eşuata! Email-ul şi/sau parola sunt incorecte.'));
						break;
					case 401:
						dispatch(loginUserFail('Conectare eşuata! Email-ul şi/sau parola sunt incorecte.'));
						break;
					case 403:
						dispatch(
							loginUserFail(
								`Momentan acest email nu este verificat. Va rugam sa verificati casuta de email pentru a verifica email-ul. <a href="/api/emailVerification/${credentials.email}"> Retrimite email de verificare.</a>`
							)
						);
						break;
					case 404:
						dispatch(loginUserFail('Conectare eşuata! Email-ul şi/sau parola sunt incorecte.'));
						break;
					default:
						dispatch(
							loginUserFail(
								'Ne pare rau, dar moment acest serviciu este indisponibil te rugam sa ne contactezi.'
							)
						);
				}
			}
		});
};

const handleHardReload = () => {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.getRegistration().then((reg) => {
			if (reg) {
				reg.unregister().then(() => {
					// Option A: Forced reload
					// window.location.reload(true);

					// Option B: Direct redirect to login
					window.location.href = '/login';
				});
			} else {
				// Same logic if no registration found
				window.location.href = '/login';
			}
		});
	} else {
		// Fallback for browsers (iOS Safari, WebViews, etc.) that don't support service workers
		window.location.href = '/login';
	}
};

export const logoutUser = () => {
	const userData = JSON.parse(localStorage.getItem('userData'));
	const url = `/api/users/${userData.userId}/logout`;
	const payload = {
		AccessUUID: jwt(userData.access).AccessUUID,
		RefreshUUID: jwt(userData.refresh).RefreshUUID
	};

	localStorage.clear();

	axios
		.post(url, payload)
		.then(() => {
			handleHardReload();
		})
		.catch((err) => {
			handleHardReload();
		});
};

export const generateResetPassword = (credentials, navigate) => (dispatch) => {
	const userResetPasswordURL = `/api/resetPassword/${credentials.email}`;
	axios
		.post(userResetPasswordURL)
		.then((response) => {
			dispatch(resetPasswordSuccess());
			navigate('/login');
		})
		.catch((err) => {
			if (err.response && err.response.data) {
				dispatch(loginUserFail(err.response.data.error));
				switch (err.response.status) {
					case 403:
						navigate(`/unverifiedEmail/${credentials.email}`);
						break;
					case 406:
						dispatch(
							loginUserFail(
								'Acest email nu a putut fi gasit. Te rugam sa incerci alt email sau sa te inregistrezi.'
							)
						);
						break;
					default:
						dispatch(
							loginUserFail(
								'Ne pare rau, dar moment acest serviciu este indisponibil te rugam sa ne contactezi.'
							)
						);
				}
			}
		});
};

export const resetPassword = (credentials, navigate) => (dispatch) => {
	const userResetPasswordURL = '/api/resetPassword';
	axios
		.patch(userResetPasswordURL, credentials)
		.then((response) => {
			if (response.status === 202) {
				dispatch(updatePasswordSuccess());
				navigate('/login');
			} else {
				throw new Error(
					'Ne pare rau, dar moment acest serviciu este indisponibil te rugam sa ne contactezi.'
				);
			}
		})
		.catch((err) => {
			if (err.response && err.response.data && err.response.data.error) {
				switch (err.response.status) {
					case 400:
						dispatch(
							updateUserStatus({
								statusMessage: err.response.data.error
							})
						);
						break;
					case 401:
						dispatch(
							updateUserStatus({
								statusMessage: err.response.data.error
							})
						);
						break;
					case 406:
						dispatch(
							updateUserStatus({
								statusMessage:
									'Acest email nu a putut fi gasit. Te rugam sa incerci alt email sau sa te inregistrezi.'
							})
						);
						break;
					default:
						dispatch(
							updateUserStatus({
								statusMessage:
									'Ne pare rau, dar moment acest serviciu este indisponibil te rugam sa ne contactezi.'
							})
						);
				}
			}
		});
};

export const verifyEmail = (email, code, type, navigate) => (dispatch) => {
	const url = '/api/verify/email?';
	const data = {};

	if (email !== '' && email !== -1 && email) {
		data.email = email;
	}

	if (code !== '' && code !== -1) {
		data.code = code;
	}

	if (type !== null) {
		data.type = type;
	}

	const searchParams = new URLSearchParams(data);

	axios
		.get(`${url}${searchParams.toString()}`)
		.then((response) => {
			dispatch(
				updateUserStatus({
					statusMessage: 'Felicitari email-ul tau este acum verificat si poate fi folosit!'
				})
			);
			navigate('/login');
		})
		.catch((err) => {
			if (err.response && err.response.data && err.response.data.error) {
				switch (err.response.status) {
					case 302:
						dispatch(
							updateUserStatus({
								statusMessage: 'Acest email este deja verificat si poate fi folosit!'
							})
						);
						navigate('/login');
						break;
					case 400:
						dispatch(
							updateUserStatus({
								statusMessage: err.response.data.error
							})
						);
						break;
					case 401:
						dispatch(
							updateUserStatus({
								statusMessage: err.response.data.error
							})
						);
						break;
					case 406:
						dispatch(
							updateUserStatus({
								statusMessage:
									'Acest email nu a putut fi gasit. Te rugam sa incerci alt email sau sa te inregistrezi.'
							})
						);
						break;
					default:
						dispatch(
							updateUserStatus({
								statusMessage:
									'Ne pare rau, dar moment acest serviciu este indisponibil te rugam sa ne contactezi.'
							})
						);
				}
			}
		});
};

export const setPlatformReport = (body, type, enqueueSnackbar) => (dispatch) => {
	const platformReportURL = '/api/platform/report';
	const { userId } = JSON.parse(localStorage.getItem('userData'));

	const payload = {
		...body,
		userId,
		type
	};

	axios
		.post(platformReportURL, payload)
		.then((response) => {
			if (response.status === 200) {
				enqueueSnackbar('Mesajul tau a fost trimis cu succes.', {
					variant: 'success'
				});
			} else {
				throw new Error(
					'Ne pare rau, dar moment acest serviciu este indisponibil te rugam sa ne contactezi.'
				);
			}
		})
		.catch((err) => {
			enqueueSnackbar(`${err}`, { variant: 'error' });
		});
};
